module.exports = __webpack_public_path__ + "assets/img/activity-time-d60be01a.png";